module.exports = __webpack_public_path__ + "img/company3.48c27c1d.png";